export const PillInputBox = ({caption, value, onChange, type, placeholder, name, required}) => {
    return (
        <div className="pill-input-box">
            <div className="input-caption">{caption}</div>
            {required && <div className="req" >*</div>}
            <input 
                type={type} 
                value={value} 
                onChange={onChange} 
                placeholder={placeholder}
                className="tr-input"
                name={name}
                required={required} 
            />
        </div>
    )
}

/** pill textArea */
export const PillTextArea = ({caption, value, onChange, name, required}) => {
    return (
    <div >
            <div className="input-caption">{caption}</div>
            {required && <div className="req" >*</div>}
            <textarea 
                value={value} 
                onChange={onChange} 
                name={name}
                required={required} 
                className="question-input"
            ></textarea>
    </div>
)}